import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import banktable2 from "assets/images/bankguarantee_table_2.svg";

import { LinkButton } from "components/buttons";
import { ASSETS_BASE_URL } from "constants";

function TradeCommodity() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`Trade Commodity<br>
              <span className="jumbotron-subtitle-2">
                Financing-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              alrajhi bank Malaysia offers customised financing solutions to
              meet clients’ import, export, open account basis and merchant
              trade needs. These cover local purchases and sales as well. Armed
              with in-depth experience in trade commodity financing and an
              understanding of both local and global markets, we work with
              buyers and suppliers throughout the global commodity supply chain
              to ascertain their specific needs and deliver bespoke financing
              solutions. This product is offered under the contract of Murabahah
              and is in compliance with the alrajhi bank Malaysia Shariah
              standard.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={banktable2}
              className="d-inline-block align-top"
              alt=""
            />

            <div className="link-button-row">
              <LinkButton
                text={
                  <span>
                    TCF-<em>i</em> Drawdown Schedule
                  </span>
                }
                onClick={() =>
                  window.open(
                    `${ASSETS_BASE_URL}assets/pdf/tradefinancing/TCF-i Drawdown Schedule.pdf`
                  )
                }
              />{" "}
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    `${ASSETS_BASE_URL}assets/pdf/tradefinancing/1680579344_Trade Finance Instruments - Fees and Charges.pdf`
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  window.open(
                    `${ASSETS_BASE_URL}assets/pdf/business-financing/PDS+-+Trade+Commodity+Financing-i.pdf`
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default TradeCommodity;
